<mat-card class="card scale-wrapper">
    <div class="dialog-actions">
        <button mat-flat-button color="primary"
            [disabled]="!firstStepForm.valid"
            (click)="saveEfficiencyScale()"
            matTooltip="{{ 'GLOBAL.SAVE' | translate }}">
            {{ 'GLOBAL.SAVE' | translate }}
        </button>
        <mat-progress-spinner *ngIf="btnDisabled" [diameter]="36" color="primary" mode="indeterminate"></mat-progress-spinner>
        <button class="buttonClose" matTooltip="{{ 'SIDEBAR_WIDGET.CLOSE' | translate }}"
            [mat-dialog-close]="true">
            <span class="material-icons">close</span>
        </button>
    </div>
    <h2>{{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.TITLE' | translate }}</h2>
    <mat-vertical-stepper #stepper linear>
        <mat-step [stepControl]="firstStepForm">
            <ng-template matStepLabel>{{'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIRST_STEP_TITLE' | translate}}</ng-template>
            <form [formGroup]="firstStepForm" class="efficiency-form">
                <field-holder kind="3-cols">
                    <mat-form-field appearance="outline">
                      <mat-label>
                        {{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIRST_STEP_FORM.DATE_OF_CREATION' | translate }}
                      </mat-label>
                      <input matInput [matDatepicker]="dateOfCreation" formControlName="dateOfCreation" readonly disabled
                        autocomplete="off" />
                      <mat-datepicker-toggle matSuffix [for]="dateOfCreation"></mat-datepicker-toggle>
                      <mat-datepicker #dateOfCreation></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>
                        {{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIRST_STEP_FORM.SUBJECT_CODE' | translate }}
                      </mat-label>
                      <input matInput type="number" formControlName="subjectCode" readonly />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>
                          {{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIRST_STEP_FORM.DOMINANT_SUPPORT_LEVEL' | translate }}
                        </mat-label>
                        <input matInput type="number" formControlName="dominantSupportLevel" required />
                        <mat-error *ngIf="firstStepForm.get('dominantSupportLevel').hasError('required')">{{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIRST_STEP_FORM.DOMINANT_SUPPORT_LEVEL_ERROR' | translate}}</mat-error>
                      </mat-form-field>
                </field-holder>
                <field-holder kind="3-cols">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.FIRST_NAME' | translate }}</mat-label>
                      <input matInput maxlength="250" type="text" formControlName="firstName" readonly autocomplete="off" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.LAST_NAME' | translate }}</mat-label>
                      <input matInput type="text" maxlength="250" formControlName="lastName" readonly autocomplete="off" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.PARENT_NAME' | translate }}</mat-label>
                      <input matInput type="text" maxlength="250" formControlName="parentName" readonly autocomplete="off" />
                    </mat-form-field>
                </field-holder>
                <field-holder kind="3-cols">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.GENDER' | translate }}</mat-label>
                      <input matInput type="text" maxlength="250" formControlName="gender" readonly autocomplete="off" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>
                        {{ 'NEW_SUBJECT.PERSONAL_DETAILS.DATE_OF_BIRTH' | translate }}
                      </mat-label>
                      <input matInput [matDatepicker]="dateOfBirth" formControlName="dateOfBirth" readonly disabled
                        autocomplete="off" />
                      <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                      <mat-datepicker #dateOfBirth></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'NEW_SUBJECT.PERSONAL_DETAILS.PLACE_OF_BIRTH' | translate }}</mat-label>
                      <input matInput type="text" maxlength="250" formControlName="placeOfBirth" readonly autocomplete="off" />
                    </mat-form-field>
                </field-holder>
                <field-holder kind="2-cols">
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="providedService" [compareWith]="compareObjects" required>
                            <mat-option *ngFor="let providedService of providedServices; let i = index" [value]="providedService">{{ providedService.title }}</mat-option>
                        </mat-select>
                        <mat-label>{{ 'SERVICE_PROVIDERS.CREATE.LICENCE.PROVIDED_SERVICE' | translate }}</mat-label>
                        <mat-error *ngIf="firstStepForm.get('providedService').hasError('required')">{{ 'SERVICE_PROVIDERS.CREATE.LICENCE.PROVIDED_SERVICE_ERROR' | translate}}</mat-error>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>
                          {{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIRST_STEP_FORM.SERVICE_PROVISION_YEAR' | translate }}
                        </mat-label>
                        <input matInput type="number" formControlName="serviceProvisionYear" required />
                        <mat-error *ngIf="firstStepForm.get('serviceProvisionYear').hasError('required')">{{ 'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIRST_STEP_FORM.SERVICE_PROVISION_YEAR_ERROR' | translate}}</mat-error>
                    </mat-form-field>
                </field-holder>
                <field-holder>
                    <mat-form-field appearance="outline">
                        <mat-label>
                          {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.STEP_01.SERVICE_PROVIDER' | translate }}
                        </mat-label>
                        <input matInput type="text" formControlName="serviceProvider" readonly autocomplete="off" />
                      </mat-form-field>
                </field-holder>
                <form-footer>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button" [disabled]="!firstStepForm.valid">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step [stepControl]="secondStepForm">
            <ng-template matStepLabel>{{'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.SECOND_STEP_TITLE' | translate}}
            </ng-template>
            <form [formGroup]="secondStepForm" class="efficiency-form">
                <table class="efficiency-table mat-elevation-z1">
                    <tbody>
                        <app-efficiency-row-form [efficiencyForm]="secondStepForm.get('toileting')"
                            [labelMap]="secondStepLabelMap.toileting" [ratings]="ratings" step="SECOND_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="secondStepForm.get('personalHygiene')"
                            [labelMap]="secondStepLabelMap.personalHygiene" [ratings]="ratings" step="SECOND_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="secondStepForm.get('dressing')"
                            [labelMap]="secondStepLabelMap.dressing" [ratings]="ratings" step="SECOND_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="secondStepForm.get('footwearManagement')"
                            [labelMap]="secondStepLabelMap.footwearManagement" [ratings]="ratings" step="SECOND_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="secondStepForm.get('eating')"
                            [labelMap]="secondStepLabelMap.eating" [ratings]="ratings" step="SECOND_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="secondStepForm.get('medicationManagement')"
                            [labelMap]="secondStepLabelMap.medicationManagement" [ratings]="ratings" step="SECOND_STEP">
                        </app-efficiency-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step [stepControl]="thirdStepForm">
            <ng-template matStepLabel>{{'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.THIRD_STEP_TITLE' | translate}}
            </ng-template>
            <form [formGroup]="thirdStepForm" class="efficiency-form">
                <table class="efficiency-table mat-elevation-z1">
                    <tbody>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('publicTransportUse')"
                            [labelMap]="thirdStepLabelMap.publicTransportUse" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('publicServicesUse')"
                            [labelMap]="thirdStepLabelMap.publicServicesUse" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('moneyManagement')"
                            [labelMap]="thirdStepLabelMap.moneyManagement" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('shopping')"
                            [labelMap]="thirdStepLabelMap.shopping" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('environmentalHygiene')"
                            [labelMap]="thirdStepLabelMap.environmentalHygiene" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('workOrEducationEngagement')"
                            [labelMap]="thirdStepLabelMap.workOrEducationEngagement" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('foodPreparation')"
                            [labelMap]="thirdStepLabelMap.foodPreparation" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('phoneUse')"
                            [labelMap]="thirdStepLabelMap.phoneUse" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="thirdStepForm.get('spatialOrientation')"
                            [labelMap]="thirdStepLabelMap.spatialOrientation" [ratings]="ratings" step="THIRD_STEP">
                        </app-efficiency-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step [stepControl]="fourthStepForm">
            <ng-template matStepLabel>{{'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FOURTH_STEP_TITLE' | translate}}
            </ng-template>
            <form [formGroup]="fourthStepForm" class="efficiency-form">
                <table class="efficiency-table mat-elevation-z1">
                    <tbody>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('ruleCompliance')"
                            [labelMap]="fourthStepLabelMap.ruleCompliance" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('communication')"
                            [labelMap]="fourthStepLabelMap.communication" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('peerRelationship')"
                            [labelMap]="fourthStepLabelMap.peerRelationship" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('socialRelationship')"
                            [labelMap]="fourthStepLabelMap.socialRelationship" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('familyRelationshipMaintenance')"
                            [labelMap]="fourthStepLabelMap.familyRelationshipMaintenance" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('communityActivityParticipation')"
                            [labelMap]="fourthStepLabelMap.communityActivityParticipation" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('riskAvoidance')"
                            [labelMap]="fourthStepLabelMap.riskAvoidance" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('aggressiveness')"
                            [labelMap]="fourthStepLabelMap.aggressiveness" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                        <app-efficiency-row-form [efficiencyForm]="fourthStepForm.get('temporalOrientation')"
                            [labelMap]="fourthStepLabelMap.temporalOrientation" [ratings]="ratings" step="FOURTH_STEP">
                        </app-efficiency-row-form>
                    </tbody>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button matStepperNext mat-stroked-button color="primary" class="form-footer__button">
                        {{ 'GLOBAL.NEXT_STEP' | translate }}
                    </button>
                </form-footer>
            </form>
        </mat-step>
        <mat-step [stepControl]="fifthStepForm">
            <ng-template matStepLabel>{{'SERVICE_PROVIDERS.FUNCTIONAL_EFFICIENCY_ASSESSMENT_SCALE.FORM.FIFTH_STEP_TITLE' | translate}}
            </ng-template>
            <form [formGroup]="fifthStepForm" class="efficiency-form">
                <table class="efficiency-table mat-elevation-z1">
                    <app-efficiency-row-form [efficiencyForm]="fifthStepForm.get('homeMobility')"
                        [labelMap]="fifthStepLabelMap.homeMobility" [ratings]="ratings" step="FIFTH_STEP">
                    </app-efficiency-row-form>
                    <app-efficiency-row-form [efficiencyForm]="fifthStepForm.get('outdoorMobility')"
                        [labelMap]="fifthStepLabelMap.outdoorMobility" [ratings]="ratings" step="FIFTH_STEP">
                    </app-efficiency-row-form>
                </table>
                <form-footer>
                    <button matStepperPrevious mat-stroked-button color="primary"
                        class="form-footer__button form-footer__button--secondary">
                        {{ 'GLOBAL.PREVIOUS_STEP' | translate }}
                    </button>
                    <button mat-flat-button mat-stroked-button (click)="preview()" class="form-footer__button form-footer__button--secondary" [disabled]="!firstStepForm.valid">
                        {{ 'SERVICE_PROVIDERS.ASSESSMENT_FORM.PREVIEW' | translate }}
                    </button>
                    <button mat-flat-button color="primary" class="form-footer__button form-footer__button--secondary" (click)="generateReport()" [disabled]="!firstStepForm.valid">
                        {{ 'GLOBAL.GENERATE' | translate }}
                    </button>
                    <mat-progress-spinner [diameter]="36" *ngIf="btnDisabled" color="primary" mode="indeterminate">
                    </mat-progress-spinner>
                </form-footer>    
            </form>
        </mat-step>
    </mat-vertical-stepper>
</mat-card>